module.exports = __webpack_public_path__ + "img/finger.7e977b95.png";